export const GET_BANK_COUNT = "GET_BANK_COUNT"
export const GET_BANK_COUNT_ERR = "GET_BANK_COUNT_ERR"
